import { format } from 'date-fns'
import type { EventDTO, FirstSourceEventDTO } from '~entities/index'
import { DISPLAY_DATE_FORMAT } from '~sharedConfig'
import { mergeEvents } from './mergeEvents'
import { parseEventDate } from './parseEventDate'

export const getFormattedEvents = (
	firstSourceEvents: FirstSourceEventDTO[] | undefined,
	secondSourceEvents: EventDTO[] | undefined
) => {
	const formattedFirstSourceEvents: EventDTO[] | undefined = firstSourceEvents?.map((event) => ({
		id: event.id,
		name: event.name,
		url: event.url,
		detail: event.detail,
		picture: event.picture,
		date: event.date
	}))

	const mergedEvents = mergeEvents(formattedFirstSourceEvents, secondSourceEvents)

	const sortedEvents = mergedEvents
		.sort((a, b) => {
			const dateA = parseEventDate(a.date)?.getTime() ?? 0
			const dateB = parseEventDate(b.date)?.getTime() ?? 0
			return dateA - dateB
		})
		.map((event) => {
			const parsedDate = parseEventDate(event.date)
			return {
				...event,
				date: parsedDate ? format(parsedDate, DISPLAY_DATE_FORMAT) : event.date,
				name: JSON.parse(`"${event.name ?? ''}"`)
			}
		})

	return sortedEvents
}
